import { sbEditable, SbEditableBlok } from '@storyblok/storyblok-editable'
import * as React from 'react'
import { HotjarEvent, useTriggerHotjarSurvey } from '../lib/hooks/useTriggerHotjarSurvey';
import { DynamicComponent } from '../components/DynamicComponent'
import { Seo } from '../components/Seo'
import { DefaultLayout } from '../layouts/DefaultLayout'
import { ThemeName } from '../lib/constants'
import { useStoryblok } from '../lib/storyblok'
import { getAnnouncementBannerFromContent } from '../components/UI/AnnouncementBanner/types'
import { getGlossaryTerms } from '../modules/GlossaryList/terms'
import { getDefinedTermSetSchema } from '../lib/utils/structuredData'
import { getCanonicalUrl } from '../lib/utils/canonicalUrl'

const PageTemplate = ({ pageContext }: { pageContext: SbEditableBlok }) => {
  let { story, content } = useStoryblok(pageContext)

  useTriggerHotjarSurvey(HotjarEvent.USER_PERSONA_SURVEY)

  const components = content.body?.map(blok => {
    return <DynamicComponent blok={blok} key={blok._uid} />
  })

  const glossaryTerms = getGlossaryTerms(content.body)
  const structuredData =
    glossaryTerms.length > 0
      ? [
          getDefinedTermSetSchema({
            name: 'Pdftools Glossary',
            url: getCanonicalUrl(pageContext),
            terms: glossaryTerms,
          }),
        ]
      : []

  return (
    <DefaultLayout
      theme={content.color_theme ? (`theme-${content.color_theme}` as ThemeName) : undefined}
      announcementBanner={getAnnouncementBannerFromContent(content)}
    >
      <Seo
        title={pageContext?.field_pageTitle_string || pageContext?.name}
        description={pageContext?.field_pageDescription_string}
        lang={pageContext?.lang}
        fullSlug={pageContext?.full_slug}
        noIndex={pageContext?.field_disableIndexing_boolean}
        translatedSlugs={pageContext?.translated_slugs}
        defaultFullSlug={pageContext?.default_full_slug}
        structuredData={structuredData}
        breadcrumbs={pageContext?.breadcrumbs}
      />
      <div {...sbEditable(story)}>{components}</div>
    </DefaultLayout>
  )
}

export default PageTemplate
